// Customizable Area Start
import React from 'react'
import { Box, TextField } from "@mui/material";
import { logo, searchIcon } from "../../customisableuserprofiles/src/assets";
// Customizable Area End

import AppHeaderController, {
  Props,
} from "./AppHeaderController";


export default class CommonHeader extends AppHeaderController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start

  // Customizable Area End

  render() {
    // Customizable Area Start
    return (
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: '115px',
        right: 0,
        zIndex: 1000,
        backgroundColor: '#ffffff',
        height: '70px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 22px',
        borderBottom: '1px solid #eaeaea',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}>
        <Box>
          <img
            onClick={this.handleHeaderLogoClick}
            src={logo}
            style={{ height: '24px', width: '148px', cursor: 'pointer' }}
            alt="Logo"
          />
        </Box>
        <Box sx={{ marginLeft: 'auto' }} style={searchContainerStyle} onKeyDown={this.handleKeyDown}>
          <img
            src={searchIcon}
            alt="Search"
            style={searchIconStyle}
          />
          <TextField
            data-test-id="search-container"
            onChange={this.handleSearchChange}
            placeholder='Search'
            variant="standard"
            InputProps={{
              disableUnderline: true,
              style: {
                fontSize: '16px',
                fontFamily: 'Inter, sans-serif',
                color: '#a5b4fc',
                lineHeight: '24px',
              },
            }}
            fullWidth
          />
        </Box>
      </Box>
    )
    // Customizable Area End
  }
}

// Customizable Area Start
const searchContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '340px',
  height: '40px',
  border: '1px solid #dadada',
  borderRadius: '40px',
  padding: '0 16px',
  backgroundColor: '#fff',
};

const searchIconStyle = {
  width: '22px',
  height: '22px',
  marginRight: '8px',
};
// Customizable Area End
